<template>
  <b-container>
    <b-row v-if="!isArtist">
      <b-col class="hero player-col">
        <h6>Get the full experience</h6>
        <h5>Join the Artist Studio<br> today.</h5>
        <b-button class="btn-rainbow px-4" :to="{name: 'artist-onboarding' }">sign up</b-button>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col class="hero player-col">
        <h6>Welcome</h6>
        <h5>Interact with your fans<br>in the Artist Studio</h5>
        <b-button class="btn-rainbow px-4" :to="{name: 'artist-dashboard' }">enter</b-button>
      </b-col>
    </b-row>

    <Headline title="Recent posts"></Headline>

    <Feed :feed="feed" v-if="feed" />

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .hero {
    text-align: center;
    padding: 1em;
    background-size: cover;
    background-position: top center;
    background-image: linear-gradient(to bottom, rgba(44,45,76,0) 0%, $body-bg), url('/static/img/fan-home-hero.jpg');

    h6 {
      font-size: 1rem;
      font-weight: 600;

      &:after {
        display: block;
        content: ' ';
        margin: 0.5em auto;
        width: 2em;
        height: 3px;

        background-color: $white;
      }

    }

    h5 {
      font-size: 1.5em;
      font-weight: 600;
    }
  }

  @include media-breakpoint-up(sm) {
    .hero {
      text-align: left;
      padding: 6em 3em;

      h6 {
        font-size: 2rem;

        &:after {
          margin: 1rem 0;
          padding: 0;
          width: 2em;
          height: 5px;
        }
      }

      h5 {
        font-size: 2.5rem;
      }

    }
  }

  .dropdown-item {
    text-decoration: none;
    color: $white;
    font-size: 0.8em;

    &:focus {
      border: 0;
      outline: 0;
    }
  }

</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import Feed from '@/components/widgets/Feed'
import Headline from '@/components/widgets/Headline'

import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    FontAwesomeIcon,
    Feed,
    Headline
  },
  data () {
    return {
      feed: null
    }
  },
  computed: {
    ...mapGetters('profile', ['isArtist'])
  },
  created () {
    this.initPage()
  },
  methods: {
    async initPage () {
      this.feed = (await this.$store.dispatch('feed/getCombinedFeed')).results
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/Home.vue